import { render, staticRenderFns } from "./TableScore.vue?vue&type=template&id=8aa2669c&scoped=true&"
import script from "./TableScore.vue?vue&type=script&lang=js&"
export * from "./TableScore.vue?vue&type=script&lang=js&"
import style0 from "./TableScore.vue?vue&type=style&index=0&id=8aa2669c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aa2669c",
  null
  
)

export default component.exports